export default "__VITE_ASSET__DEmgppej__"